/** Mirrors server utils/businessScope.js (routes/businesses listing rules). */
export function hasGlobalBusinessAccessUser(
  user: { role?: string; permissions?: Record<string, boolean> } | null | undefined
): boolean {
  if (!user) return false;
  if (['admin', 'agent', 'developer', 'tv_dashboard'].includes(user.role || '')) return true;
  return user.permissions?.view_all_businesses === true;
}
